import { ClassificationResultView, ContentClassificationView, ContentView } from '../api/client'

export type ClassifiersToDisplay = {
    relevantSevereClassifications: ContentClassificationView[]
    relevantSuspectClassifications: ContentClassificationView[]
    safeClassifications: ContentClassificationView[]
}

/**
 * Buckets a comment's classifications into the lists the pills render from.
 *
 * The verdict IS the queue: raku stamped it against this account's boundaries at
 * classification time, including the inversion SENTIMENT needs, so there is
 * nothing to compare here. The search only returns classifiers that actually ran
 * on the comment, so the admin overflow needs no score floor to hide a tail of
 * near-zeros. — Claude
 */
export function getClassifiersToDisplay(content: ContentView): ClassifiersToDisplay {
    const buckets: ClassifiersToDisplay = {
        relevantSevereClassifications: [],
        relevantSuspectClassifications: [],
        safeClassifications: []
    }

    for (const classification of content.allClassifications) {
        if (classification.result === ClassificationResultView.Yes) {
            buckets.relevantSevereClassifications.push(classification)
        } else if (classification.result === ClassificationResultView.Maybe) {
            buckets.relevantSuspectClassifications.push(classification)
        } else {
            buckets.safeClassifications.push(classification)
        }
    }

    return buckets
}
